import { Notyf } from "notyf";

export const pause = (ms: number) => new Promise((res) => setTimeout(res, ms));

let timer: NodeJS.Timeout | undefined;
export function delay(ms: number) {
    return function (callback: () => void) {
        clearTimeout(timer);
        timer = setTimeout(callback, ms);
    };
}

/**
 * Renvoie le zIndex calculé de l'élement selector
 *
 * @param selector string selecteur css de l'element
 * @returns number le zIndex de l'element
 */
function getElementZIndex(selector: string): number {
    let res = 0;

    if (selector) {
        const zIndex = getStyle(selector, "z-index");
        if (zIndex) {
            res = !isNaN(Number(zIndex)) ? Number(zIndex) : 0;
        }
    }

    return res;
}

function createSpinner(parentSelector: string, showTimer: boolean = false): JQuery<HTMLElement> {
    const res = $("<div>").addClass("spinner");
    let zIndex = 0;

    if (parentSelector) {
        const zInd = getElementZIndex(parentSelector);
        if (zInd) {
            zIndex = zInd + 1;
            res.css("z-index", zIndex.toString());
        }
    }

    // Ajout du timer
    if (showTimer) {
        res.append(/* html */ `
            <div class="loader-timer-value" style="z-index:${zIndex + 1};">
                00:00
            </div>`);
    }

    return res;
}

const spinnerMap = new Map<string, JQuery<HTMLElement>>();
const startTimesMap = new Map<string, number>();
const timerMap = new Map<string, number>();

export function asterStartLoader(target: string = "body", showTimer: boolean = false) {
    if (spinnerMap.has(target)) {
        console.warn("already loading on", target);
        return;
    }
    spinnerMap.set(target, createSpinner(target, showTimer));
    $(target).css("position", "relative");
    $(target).css("overflow", "auto");
    $(target).append(spinnerMap.get(target)!);

    if (showTimer) {
        startTimesMap.set(target, Date.now());
        timerMap.set(
            target,
            window.setInterval(() => {
                const spinner = spinnerMap.get(target);
                const loaderStartTime = startTimesMap.get(target);
                if (loaderStartTime) {
                    const elapsedMs = Date.now() - loaderStartTime;
                    if (elapsedMs < 5_000) {
                        return;
                    } else {
                        if (spinner) {
                            $(spinner).find(".loader-timer-value").show();
                        }
                    }
                    const min = Math.floor(elapsedMs / 60000)
                        .toString()
                        .padStart(2, "0");
                    const sec = Math.floor((elapsedMs % 60000) / 1000)
                        .toString()
                        .padStart(2, "0");
                    /* const ms = Math.floor(elapsedMs % 100)
                        .toString()
                        .padStart(2, "0"); */
                    if (spinner) {
                        $(spinner).find(".loader-timer-value").text(`${min}:${sec}`);
                    }
                }
            }, 1000),
        );
    }
}

export function asterEndLoader(target: string = "body") {
    if (!spinnerMap.has(target)) {
        console.warn("no spinner on", target);
        return;
    }
    $(target).css("position", "");
    $(target).css("overflow", "");
    const spinner = spinnerMap.get(target);
    spinner?.remove();
    spinnerMap.delete(target);

    // Suppression du timer
    if (timerMap.has(target)) {
        const loaderTimerInterval = timerMap.get(target);
        clearInterval(loaderTimerInterval);
        timerMap.delete(target);
    }
    startTimesMap.delete(target);
}

export function getStyle(selector: string, styleProp: string): string | null {
    let res: string | null = null;
    const element = document.querySelector(selector);

    if (element != null) {
        res = document.defaultView?.getComputedStyle(element, null).getPropertyValue(styleProp) ?? null;
    }

    return res;
}

export const baseUrl = window["base_url"];

export const toaster = new Notyf({
    duration: 5000,
    dismissible: true,
    position: {
        x: "right",
        y: "top",
    },
});

export function showError(message: string) {
    toaster.error({ message, duration: 10_000 });
}

export function bootstrapDetectBreakpoint() {
    // cache some values on first call
    const breakpointNames = ["xxl", "xl", "lg", "md", "sm", "xs"];
    const breakpointValues = [];
    const isPriorBS5 = !!window.getComputedStyle(document.documentElement).getPropertyValue("--breakpoint-sm");
    const prefix = isPriorBS5 ? "--breakpoint-" : "--bs-breakpoint-";
    for (const breakpointName of breakpointNames) {
        const value = window.getComputedStyle(document.documentElement).getPropertyValue(prefix + breakpointName);
        if (value) {
            breakpointValues[breakpointName] = value;
        }
    }
    let i = breakpointNames.length;
    for (const breakpointName of breakpointNames) {
        i--;
        if (window.matchMedia("(min-width: " + breakpointValues[breakpointName] + ")").matches) {
            return { name: breakpointName, index: i };
        }
    }
    return null;
}
